import React from "react";
import { Link } from "react-router-dom";
import { footer } from "../styles/index";

const Footer = () => (
  <footer style={footer.container}>
    <div style={footer.inner}>
      <div style={footer.text}>
        © {new Date().getFullYear()} SimulateJob. All rights reserved.
      </div>

      <div style={footer.links}>
        <Link to="/terms" style={footer.link}>
          Terms
        </Link>
        <Link to="/privacy" style={footer.link}>
          Privacy
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
